import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular-boost';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LosMenuV2Model } from '../models/los-menu-v2.model';

@Injectable({
  providedIn: 'root'
})
export class LosMenusV2Service {

  private queryMenus = gql`
  query menusIds($menus: [String!]!) {
    menusIds(menus: $menus) {
      _id
      name
      path
      icon
      description
      order
      isPublic
      applicationId
      application {
        _id
        name
        description
        url
        icon
        version
        port
        host
        systemId
        applicationTypeId
        active
        deletedAt
      }
      menuId
      active
      deletedAt
    }
  }
  `;

  constructor(
    private apollo: Apollo
  ) { }

  getMenus(menus: string[]): Observable<LosMenuV2Model[]> {
    return this.apollo.use('public').query<any>({
      query: this.queryMenus,
      variables: {
        menus: menus
      }
    }).pipe(map(response => {
      return response.data.menusIds as LosMenuV2Model[];
    }));
  }
}
